'use client';

import { memo } from 'react';

export const UpgradePrompt = memo(() => {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-3 p-8 text-center">
      <p className="font-semibold text-24 text-gray-12">
        Upgrade to Enterprise to access your Air workspace in Shopify
      </p>
      <p className="text-16 text-gray-11">Air's Shopify plugin is available on the Enterprise plan.</p>
      <a
        className="mt-1 rounded-8 bg-altitude-9 px-4 py-2 font-semibold text-14 text-white hover:bg-altitude-10"
        href="https://air.inc/pricing"
        rel="noopener noreferrer"
        target="_blank"
      >
        Explore plans
      </a>
    </div>
  );
});

UpgradePrompt.displayName = 'UpgradePrompt';
